<template>
    <div v-if="visible" class="countdownContainer">
	    <div class="counterContainer clearfix">
	        <div class="digitContainer">{{days | firstDigit}}</div>
	        <div class="digitContainer second">{{days | secondDigit}}</div>
	        <div class="digitContainer">{{hours | firstDigit}}</div>
	        <div class="digitContainer second">{{hours | secondDigit}}</div>
	        <div class="digitContainer">{{minutes | firstDigit}}</div>
	        <div class="digitContainer last">{{minutes | secondDigit}}</div>
	    </div>
	    <div class="textContainer clearfix">
	        <div class="textContainerElement">Tagen</div>
	        <div class="textContainerElement">Stunden</div>
	        <div class="textContainerElement last">Minuten</div>
	    </div>
    </div>
</template>

<script>
   export default {
	   name: 'countdown',
	   mounted() {
		   window.setInterval(() => {
		       this.now = Math.trunc((new Date()).getTime());
	       },10000);
	   },
	   props: {
		   date: {
		      type: String,
		      required: true
		    }
	   },
	   data: function() {
	       return {
	    	   now: Math.trunc((new Date()).getTime())
	       }
	   },
	   computed: {
		   visible() {
			   if(this.days.toString().length < 3) {
                   return true;
               }
			   return false;
		   },
		   minutes() {
			   var minutes = Math.trunc((this.date - this.now) / (60 * 1000)) % 60;
			   if(minutes < 0) {
				   return 0;
			   }
		       return minutes;
		   },
		   hours() {
			   var hours = Math.trunc((this.date - this.now) / (60 * 60 * 1000)) % 24;
			   if(hours < 0) {
				   return 0;
			   }
		       return hours;
		   },
		   days() {
			   return Math.trunc((this.date - this.now) / (60 * 1000) / 60 / 24);
		   }
	   },
	   filters: {
		   firstDigit: function (value) {
			   if(value < 10) {
				   return 0;
			   }
			   return value.toString().substring(0,1);
		   },
		   secondDigit: function (value) {
			   if(value < 10) {
                   return value.toString().substring(0,1);
			   }
			   return value.toString().substring(1,2);
           }
	   }
   }
</script>


// WEBPACK FOOTER //
// Countdown.vue?22b20c4a